export default {
  navigation: {
    section: 'Facturation',
    billing: 'Facturation',
    usage: 'Consommation',
  },
  page: {
    title: 'Facturation',
    subtitle: 'Votre solde, ce que vous consommez et vos factures. Montants hors taxes.',
    subtitleVolumes: 'Ce que vos contenus consomment, jour par jour.',
    balance: 'Solde {amount}',
    tabs: {
      overview: 'Vue d’ensemble',
      usage: 'Consommation',
      history: 'Historique',
      preferences: 'Réglages',
    },
  },

  overview: {
    noWallet:
      'Cette plateforme n’accorde pas de crédits : aucun portefeuille n’est ouvert pour cette organisation.',
    viewPricing: 'Voir le détail des tarifs',
    pending: {
      message: 'Une recharge de {amount} attend votre paiement.',
      detail: 'Elle expire le {date}. Rien n’a été débité.',
      pay: 'Payer',
      cancel: 'Annuler',
    },
    // A top-up whose direct debit the bank is collecting: nothing to do but wait.
    collecting: {
      message: 'Le paiement de votre recharge de {amount} est en cours.',
      detail:
        'Vos crédits seront ajoutés automatiquement dès que votre banque aura confirmé le prélèvement, ce qui prend en moyenne 8 jours.',
    },
    balance: {
      label: 'Solde disponible',
      runway: '≈ {days} jours',
      runwayHint: 'Au rythme de {rate} par jour',
      bought: '{amount} achetés, sans expiration',
      granted: '{amount} offerts, jusqu’au {date}',
      grantedNoDate: '{amount} offerts',
      nextGrant: 'Prochaine dotation de {amount} le {date}',
      incoming: '+ {amount} en attente : un prélèvement est en cours, les crédits seront ajoutés dès sa confirmation',
      autoTopUp: 'Auto-recharge',
      autoTopUpOn: 'activée',
      autoTopUpOff: 'désactivée',
      configure: 'Régler',
      activate: 'Activer',
    },
    month: {
      spent: 'Dépensé en {month}',
      projection: 'Fin de mois estimée',
      chart: 'Dépense par jour en {month}',
    },
    breakdown: {
      title: 'Où va votre crédit ce mois-ci',
      details: 'Consommation détaillée',
      empty: 'Rien de consommé ce mois-ci.',
      included: 'Inclus',
      categories: {
        subscriptions: 'Chaînes et domaines',
        storage: 'Stockage',
        subtitles: 'Sous-titres',
        delivery: 'Diffusion',
        other: 'Autres',
      },
      subscriptionsCount: '{count} abonnement | {count} abonnements',
      storageVolume: '{duration} de vidéo · {size} au total',
      subtitlesVolume: 'Transcriptions et traductions',
      deliveryVolume: '{used} sur {included} inclus',
    },
    subscriptions: {
      title: 'Abonnements',
      next: 'prochain débit le {date}',
    },
    recent: {
      title: 'Derniers mouvements',
      all: 'Tout l’historique',
      empty: 'Aucun mouvement pour l’instant.',
    },
  },

  credits: {
    deletionNotice:
      'Votre portefeuille est vide depuis un moment : vos contenus hébergés pourront être supprimés à partir du {date}. Rechargez pour l’éviter.',
    allocations: {
      sources: {
        purchase: 'Recharge',
        grant: 'Dotation offerte',
        bonus: 'Bonus de recharge',
        auto_renewal: 'Auto-recharge',
        refund: 'Remboursement',
        adjustment: 'Ajustement',
      },
    },
  },
  recurring: {
    kinds: {
      channel: 'Chaîne',
      domain: 'Domaine personnalisé',
    },
    status: {
      active: 'Actif',
      past_due: 'Impayé',
      suspended: 'Suspendu',
      cancelled: 'Résilié',
    },
    graceEnds: 'Mise hors ligne le {date}',
  },
  preferences: {
    identity: {
      title: 'Identité de facturation',
      lede: 'Ce qui figure sur vos factures.',
      edit: 'Modifier',
      fill: 'Renseigner',
      empty: 'Aucune identité enregistrée : elle vous sera demandée à votre première recharge.',
      unavailable: 'Le service de facturation ne répond pas : l’identité de facturation ne peut pas être affichée pour le moment.',
      vat: 'TVA intracommunautaire',
      vatValid: 'vérifié',
      vatInvalid: 'inconnu de VIES',
    },
    explainer: {
      title: 'Comment fonctionne le portefeuille',
      facts: '1 crédit = 1 € HT · des crédits offerts chaque mois · un bonus sur les recharges',
    },
  },
  history: {
    views: {
      label: 'Afficher',
      movements: 'Mouvements',
      documents: 'Factures et avoirs',
    },
    filters: {
      label: 'Type de mouvement',
      all: 'Tout',
      topUps: 'Recharges',
      consumption: 'Consommation',
      grants: 'Offerts',
      refunds: 'Remboursements',
      expirations: 'Expirations',
    },
    export: 'Exporter en CSV',
    empty: 'Aucun mouvement pour l’instant.',
    emptyFiltered: 'Aucun mouvement de ce type.',
    loadMore: 'Afficher plus',
    folded: '{from} – {to} · {count} jour | {from} – {to} · {count} jours',
    showDays: 'Voir le détail jour par jour',
    hideDays: 'Masquer le détail',
    balanceAfter: 'Solde après : {amount}',
    topUp: {
      title: 'Recharge',
      auto: 'Auto-recharge',
      paid: 'Payée',
      withBonus: '{amount} + {bonus} de bonus',
      invoice: 'Télécharger la facture',
      detail: 'Voir le détail',
      expiresOn: 'expire le {date}',
      collecting: 'crédits ajoutés dès que votre banque aura confirmé le prélèvement',
    },
    csv: {
      filename: 'mouvements',
      date: 'Date',
      type: 'Type',
      description: 'Description',
      amount: 'Montant (€ HT)',
      balance: 'Solde après (€)',
    },
  },
  creditHistory: {
    types: {
      purchase: 'Recharge',
      grant: 'Dotation offerte',
      bonus: 'Bonus',
      auto_renewal: 'Auto-recharge',
      consumption: 'Consommation',
      refund: 'Remboursement',
      adjustment: 'Ajustement',
      expiration: 'Expiration',
    },
    // Keyed on the line's kind, its service and its top-up (`apps/billing/journal.ts`), never on
    // the server's English description.
    descriptions: {
      freeCredit: 'Crédit offert du mois',
      bonus: 'Bonus de la recharge',
      topUp: 'Crédits achetés',
      autoTopUp: 'Crédits achetés par l’auto-recharge',
      refund: 'Crédits repris par un remboursement',
      expired: 'Crédit offert non utilisé, expiré',
      skus: {
        storage_daily: 'Stockage de fichiers',
        storage_video_daily: 'Stockage vidéo',
        // The first month of a file's storage, debited when it lands, a video's when it is measured.
        storage_first_month: 'Premier mois de stockage',
        storage_video_first_month: 'Premier mois de stockage vidéo',
        bandwidth_delivered: 'Diffusion au-delà de la franchise',
        subtitles_transcription: 'Transcription automatique',
        subtitles_translation: 'Traduction automatique',
        websites_channel_monthly: 'Chaîne, abonnement mensuel',
        websites_domain_monthly: 'Domaine personnalisé, abonnement mensuel',
      },
    },
  },
  purchases: {
    pay: 'Payer',
    reconcile: 'Vérifier auprès du service de facturation',
    cancel: 'Annuler',
    cancelConfirm: {
      title: 'Annuler cette recharge ?',
      message:
        'La recharge de {amount} sera close et ne pourra plus être payée. Rien n’a été débité et rien ne le sera.',
      confirm: 'Annuler la recharge',
      keep: 'Garder',
    },
    cancelled: 'Recharge annulée. Rien n’a été débité.',
    cancelRefused:
      'Cette recharge ne peut plus être annulée : elle a été payée entre-temps, et ses crédits sont sur le portefeuille.',
    reconciled: {
      paid: 'Paiement confirmé : les crédits sont sur le portefeuille.',
      pending: 'Le paiement est encore en cours chez le service de facturation ({status}). Réessayez plus tard.',
      closed: 'Cette recharge a été close sans paiement ({status}). Rien n’a été débité.',
      not_opened:
        'Cette recharge n’a jamais atteint le service de facturation : il n’y a rien à vérifier et rien n’a été débité.',
    },
  },
  documents: {
    empty: 'Aucune facture pour l’instant.',
    download: 'Télécharger le PDF',
    pdfPending: 'PDF en cours de génération',
    notReady: 'Ce document est émis mais son PDF n’est pas encore prêt. Réessayez dans un instant.',
    settled: 'réglé : {amount}',
    filters: {
      kind: 'Type de document',
      allKinds: 'Tous les types',
    },
    kinds: {
      invoice: 'Facture',
      credit_note: 'Avoir',
    },
    table: {
      number: 'Numéro',
      kind: 'Type',
      issuedOn: 'Émise le',
      exclTax: 'HT',
      inclTax: 'TTC',
    },
  },
  identity: {
    kind: 'Vous achetez en tant que',
    kindFrozen: 'Vous achetez en tant que {kind}. Ce choix ne peut plus être modifié.',
    kinds: {
      company: 'entreprise',
      individual: 'particulier',
    },
    kindOptions: {
      company: 'Entreprise',
      individual: 'Particulier',
    },
    contactName: 'Nom du contact',
    fullName: 'Prénom et nom',
    companyName: 'Raison sociale',
    email: 'E-mail de facturation',
    country: 'Pays',
    line1: 'Adresse',
    line2: 'Complément d’adresse',
    postalCode: 'Code postal',
    city: 'Ville',
    vatNumber: 'Numéro de TVA intracommunautaire (facultatif)',
    vat: {
      valid: 'Numéro de TVA vérifié',
      invalid: 'Numéro inconnu de VIES : corrigez-le ou videz le champ.',
      unknown: 'Numéro de TVA pas encore vérifié : le registre européen (VIES) ne répond pas pour l’instant.',
    },
    saved: 'Identité de facturation enregistrée.',
  },
  common: {
    perMonth: '/mois',
  },
}
